<template>
  <div>
    <v-toolbar
      elevation="1"
      dark
      color="highlight"
      flat
      v-bind:class="$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb'"
      dense
    >
      <v-toolbar-title>{{ blueprint != null ? blueprint.name: ''}}</v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-if="!uploadForm">
        <!-- <v-toolbar-items> -->
        <scanQRCode v-on:showMarkerDetails="showMarkerDetails"></scanQRCode>
        <!-- </v-toolbar-items> -->
        <!-- <v-toolbar-items> -->
        <!-- </v-toolbar-items> -->
        <!-- <v-toolbar-items> -->
        <template v-if="!$store.state.isOffline">
          <can I="update" a="blueprints">
            <v-btn
              class="ml-3"
              small
              depressed
              dark
              color="secondary"
              @click="updateBlueprint"
            >{{$t('save')}}</v-btn>
          </can>
        </template>
        <!-- </v-toolbar-items> -->
      </template>
    </v-toolbar>
    <v-sheet tile v-if="$store.state.readyForOffline && $store.state.allAttributes && $store.state.productSolutions" class="text-center white--text" flat color="green">
      <template v-if="!$store.state.isOffline">
        <v-icon color="white">done</v-icon> {{$t('readyForOffline')}}
      </template>
      <template v-else>
        <v-icon color="white">cached</v-icon> {{$t('goOnline')}}
      </template>
      </v-sheet>
    <uploadBlueprint :blueprintId="blueprint.id" v-if="uploadForm"></uploadBlueprint>
    <template v-else>
      <!-- <v-card flat> -->
      <v-layout v-if="blueprint" wrap>
        <v-flex lg5 xs12>
          <v-container grid-list-md text-xs-center>
            <v-card>
              <v-container>
                <v-form v-model="valid">
                  <can I="update" a="blueprints">
                    <v-text-field
                      outlined
                      dense
                      :disabled="$store.state.isOffline"
                      :rules="nameRules"
                      required
                      v-model="blueprint.name"
                      v-bind:label="$t('name')"
                    ></v-text-field>
                    <v-menu
                      transition="scale-transition"
                      origin="right top"
                      offset-y
                      ref="menu1"
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          dense
                          :disabled="$store.state.isOffline"
                          v-model="blueprint.deadline"
                          readonly
                          v-bind:label="$t('deadline')"
                          persistent-hint
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="blueprint.deadline" no-title></v-date-picker>
                    </v-menu>
                    <can I="update" a="blueprints">
                      <v-layout>
                        <v-select
                          outlined
                          :menu-props="{ bottom: true, offsetY: true }"
                          dense
                          :disabled="$store.state.isOffline"
                          v-model="blueprint.installers"
                          :items="blueprint.allInstallers"
                          v-bind:label="$t('installer')"
                          chips
                          item-value="id"
                          item-text="fullName"
                          multiple
                          return-object
                        >
                          <!-- <template slot="selection" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                          </template>-->
                        </v-select>
                      </v-layout>
                    </can>
                    <v-textarea
                      outlined
                      v-model="blueprint.description"
                      v-bind:label="$t('description')"
                    ></v-textarea>
                  </can>
                </v-form>
              </v-container>
            </v-card>
            <markers
              class="mb-6 mt-3"
              :blueprintFile="blueprint.blueprintFile"
              v-on:showMarkerDetails="showMarkerDetails"
              :markers="markers"
            ></markers>
          </v-container>
        </v-flex>
        <v-flex
          v-if="(blueprint.blueprintFile && !blueprint.blueprintFile.content) || !$store.state.isMobile"
          lg7
          xs12
        >
          <v-container :class="fullscreen ? 'sticky-blueprint': 'sticky-blueprint-fullscreen'">
            <zoomMarkup
              ref="markup"
              v-on:fullscreen="toggleFullscreen"
              v-on:showMarkerDetails="showMarkerDetails"
              v-bind:blueprint="blueprint"
            ></zoomMarkup>
          </v-container>
        </v-flex>
      </v-layout>
      <v-container v-else fill-height>
        <loading></loading>
      </v-container>
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card flat color="primary" dark>
          <v-card-text>
            {{loadingText}}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- </v-card> -->
    </template>
    <div
      v-if="blueprint && blueprint.blueprintFile && blueprint.blueprintFile.content && $store.state.isMobile"
      outlined
      color="primary"
      class="floating-button"
    >
      <zoomMarkup
        ref="markup"
        v-on:showMarkerDetails="showMarkerDetails"
        v-bind:blueprint="blueprint"
      ></zoomMarkup>
    </div>
    <savebeforeleave v-on:response="response" :dialog="saveDialog"></savebeforeleave>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

import uploadBlueprint from "@/components/pages/Blueprints/UploadBlueprint";
import markers from "@/components/pages/Markers/Edit/List";
import zoomMarkup from "@/components/pages/Markers/ZoomMarkup";
import jwtdecode from "jwt-decode";
import async from "async";
import scanQRCode from "@/components/pages/Markers/ScanQRCode";

import { serviceihub } from "@/services/service.ihub.js";

import { Promise } from "q";

const _serviceIhub = new serviceihub();

export default {
  name: "blueprintsDetails",
  components: {
    uploadBlueprint,
    markers,
    zoomMarkup,
    scanQRCode,
  },
  beforeRouteLeave(to, from, next) {
    console.log(`BeforeRouteLeave: Store is ${this.$store.state.isOffline ? 'offline' : 'online'}, Store ${this.$store.state.hasChanges ? "has changes" : "has no changes"}`);
    /*Before someone goes to other page (in app)
    show a warning if they are working offline.
    If they leave the page, offline changes will not be saved
    */
    if (this.$store.state.isOffline && to.name != "EditMarkerDetails") {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      if (this.$store.state.hasChanges && !this.$store.state.isOffline) {
        this.saveDialog = true;
        this.$store.state.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        this.$store.state.hasChanges = false;
        if (to.name != "EditMarkerDetails") {
          if (this.$can("update", "markers")) {
            if (
              this.blueprint.isLocked &&
              this.blueprint.lockedByUserId ==
                parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
            ) {
              this.$http
                .lockBlueprint(this.blueprint.id)
                .then((res) => {
                  if (to.name === "Login") {
                    localStorage.removeItem("auth");
                    localStorage.removeItem("user");
                  }
                  this.$store.state.markers = [];
                  next();
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              next();
            }
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  },
  data() {
    return {
      blueprint: null,
      loadingText: "",
      hideMarkup: false,
      dialog: false,
      uploadForm: false,
      attributeTypes: null,
      leadThroughTypes: null,
      insulationTypes: null,
      menu: false,
      valid: false,
      nameRules: [(v) => !!v || `${this.$t("name")} ${this.$t("required")}`],
      markers: [],
      image: null,
      saveDialog: false,
      to: null,
      fullscreen: false,
      prevRoute: null,
    };
  },
  computed: {
    markersui() {
      return this.$store.getters.markersui;
    },
    isOffline() {
      return this.$store.state.isOffline;
    },
  },
  methods: {
    toggleFullscreen(f) {
      this.fullscreen = !f;
    },
    async getAllAttributesAndSaveInStore() {
      if (this.$store.state.allAttributes == null) {
        try {
          let res = await this.$http.getAttributes(false, true);
          this.$store.state.allAttributes = res.data;
        } catch (err) {
          console.log(err);
        }
      }
    },
    checkIfBlueprintIsLocked() {
      if (this.blueprint.isLocked) {
        if (
          this.blueprint.lockedByUserId !=
          parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
        ) {
          this.$noty.info(
            `${this.blueprint.lockedByUserName}  ${this.$t(
              "blueprintLockedSince"
            )} ${this.blueprint.lockedTs}`
          );

          this.$router.push({
            name: "BlueprintsDetails",
            params: { id: this.$route.params.id },
          });
        }
      } else {
        this.$router.push({
          name: "BlueprintsDetails",
          params: { id: this.$route.params.id },
        });
      }
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("projects"),
          to: { name: "Projects" },
        },
        {
          name: this.blueprint.project,
          to: {
            name: "ProjectDetails",
            params: { id: this.blueprint.projectId },
          },
        },
        {
          name: this.blueprint.buildingComponent,
          to: {
            name: "BuildingComponentDetails",
            params: { id: this.blueprint.buildingComponentId },
          },
        },
        {
          name: this.blueprint.name,
        },
      ];
    },
    response(answer) {
      if (answer) {
        this.$refs.markup.$refs.markupFullscreen.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params,
      });
    },
    updateBlueprint() {
      if (this.valid) {
        
        this.blueprint.buildingComponent = null;
        this.$http
          .updateBlueprint(this.blueprint)
          .then((res) => {
            this.$noty.success('<i class="fas fa-check"></i>');
          })
          .catch((err) => {
            this.$noty.error(err);
            console.log(err);
          });
      }
    },
    showMarkerDetails(marker) {
      this.$router.push({
        name: "EditMarkerDetails",
        params: {
          id: marker.id,
          marker: marker,
          blueprint: this.blueprint,
        },
      });
    },
    setOffline() {
      if (navigator.onLine) {
        this.$store.state.isOffline = !this.$store.state.isOffline;
      }
    },
  },
  async mounted() {
    try {
      if (this.$store.state.isOffline) {
        this.blueprint = this.$route.params.blueprint;
        this.$store.state.previous = {
          name: "BuildingComponentDetails",
          id: this.blueprint.buildingComponentId,
        };
      } else {
        this.blueprint = this.$route.params.blueprint;
        if (this.blueprint) {
          if (this.blueprint.id != this.$route.params.id) {
            let resBlueprint = await this.$http.getBlueprint(
              this.$route.params.id
            );
            if (resBlueprint.data.blueprintFileId == null) {
              this.uploadForm = true;
            }
            this.blueprint = resBlueprint.data;
          }
          this.checkIfBlueprintIsLocked();
          this.$store.state.previous = {
            name: "BuildingComponentDetails",
            id: this.blueprint.buildingComponentId,
            breadcrumb: this.$t("buildingComponent"),
          };
        } else {
          let resBlueprint = await this.$http.getBlueprint(
            this.$route.params.id
          );
          if (resBlueprint.data.blueprintFileId == null) {
            this.uploadForm = true;
          }
          this.blueprint = resBlueprint.data;
          this.checkIfBlueprintIsLocked();
          this.$store.state.previous = {
            name: "BuildingComponentDetails",
            id: this.blueprint.buildingComponentId,
            breadcrumb: this.$t("buildingComponent"),
          };
        }

        if (this.$store.state.productSolutions == null) {
          let resProductSolutions = await this.$http.getProductSolutions(true);
          this.$store.state.productSolutions = resProductSolutions.data;
        }

        let offline = {
          // offInstallers: null,
          offUnusedAttributes: null,
        };
        let requests = [];
        // requests.push(this.$http.getProductSolutions(true)); already loaded in line 418
        // requests.push(this.$http.getAttributes(true, true));

        Promise.all(requests).then((res) => {
          // this.$store.state.productSolutions = res[0].data;

          // offline.offUnusedAttributes = res[0].data;
          //
          this.dialog = false;
          this.$store.state.offline = offline;
          this.loadingText = this.$t("wait2");
        });
      }
      this.makeBreadcrumb();
      this.getAllAttributesAndSaveInStore();
      this.checkIfBlueprintIsLocked();
    } catch (err) {
      console.log(err);
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  created() {},
  watch: {
    blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id },
          });
        }
      }
    },
  },
};
</script>


<style scoped>
.v-input--selection-controls {
  margin-top: 12px;
}
.v-messages .theme--light {
  height: 0px !important;
  min-height: unset !important;
}
</style>


// WEBPACK FOOTER //
// src/views/blueprints/edit/BlueprintsDetails.vue